<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { useSession } from "../api";
import { TableIcon } from "../icons";
import { datasetIcons } from "../datasetIcons";
import { vSize } from "../directives/geometry";
const props = withDefaults(defineProps<{ dataset: any; size?: number }>(), {
  size: 24,
});
const session = useSession(),
  failed = ref(false);
const url = computed(
  () =>
    `/api/datasets/${props.dataset.id}/favicon?organization=${session.organization}&v=${props.dataset.favicon_revision ?? 0}`,
);
watch(url, () => (failed.value = false));
watch(
  () => props.dataset.favicon_status,
  () => (failed.value = false),
);
</script>
<template>
  <span class="dataset-avatar" v-size="size"
    ><img
      v-if="!dataset.icon_name && dataset.favicon_status === 'ready' && !failed"
      :src="url"
      :width="size"
      :height="size"
      alt=""
      @error="failed = true" /><component
      v-else
      :is="
        datasetIcons.find((i) => i.id === dataset.icon_name)?.component ??
        TableIcon
      "
      :size="size"
  /></span>
</template>
<style scoped lang="scss" src="../styles/components/DatasetAvatar.scss"></style>
